import {
  GetSupplierHearingSheetItemRes
} from '@gateway.Supplier'
import { yamadumiApi } from '../yamadumi-api'

export class HearingSheetItemGateway {
  /**
  * 業者ヒアリング(ヒアリングシート)-取得
  */
  static getHearingSheetItem = async (
    simulationYm: string,
    supplierCd: string,
    factoryCd: string,
    expenseCd: string,
    supplierBranchCd: string
  ) => {
    const params = {
      simulationYm,
      supplierCd,
      factoryCd,
      expenseCd,
      supplierBranchCd
    }
    return await yamadumiApi.get<GetSupplierHearingSheetItemRes>(
      '/api/supplier/hearing/sheet/item',
      params
    )
  }
}
